import React from "react";
import { useEffect, useState, useRef } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { getTemplateData } from "../services/apiservice";
import "react-responsive-modal/styles.css";
import "../styles/template.css";
import "../styles/redemption-form.css";
import Footer from "./Footer";
import GradientHeader from "./GradientHeader";
import SizeVariantSelect from "./SizeVariantSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUpload } from "@fortawesome/free-solid-svg-icons";
import successDialogSvg from "../assets/images/success_dialog.svg";
import requestFailedSvg from "../assets/images/Request_Failed.svg";
import { toast, ToastContainer } from "react-toastify";

const getVariantKey = (product, index) => {
  if (product?.pack_id != null && product?.product_id != null) {
    return `${product.pack_id}_${product.product_id}`;
  }
  return `${product?.product_id}_${index}`;
};

export const RedemptionForm = () => {
  let [loading, setLoading] = useState(true);
  let [products, setProducts] = useState([]);
  const [_, setFilteredVariants] = useState([]);
  const [modalShown, setModalShown] = useState(false);
  const [modalType, setModalType] = useState("success"); // "success" or "failure"
  const [variants, setVariants] = useState(new Map());
  const [swagpackIds, setSwagpackIds] = useState([]);
  const [caricaturePreview, setCaricaturePreview] = useState(null);
  const [showOnlyEmail, setShowOnlyEmail] = useState(false);
  const [redemptionData, setRedemptionData] = useState({
    backroundColor: "",
    logoImageUrl: "",
    buttonColor: "",
    logoImage: "",
    footerColor: "",
    headerColor: "",
    footerText: "",
    customerId: null,
  });
  const [address, setAddress] = useState({
    first_name: "",
    last_name: "",
    email: "",
    emp_id: -1,
    calling_code: "+91",
    phone: "",
    address1: "",
    address2: "",
    address3: "",
    landmark: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    size: "",
    gender: "",
    image_url: "",
  });
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get("token");
  let navigate = useNavigate();
  let params = { token: token };
  const { state } = useLocation();
  const selectedPack = state?.selectedPack;
  const swagpacks = selectedPack?.selectedPack;
  const [errors, setErrors] = useState({});
  const [campaignId, setCampaignId] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [popupImageUrl, setPopupImageUrl] = useState("");
  const [showCropPopup, setShowCropPopup] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [onelinkRequestId, setOnelinkRequestId] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startPoint, setStartPoint] = useState({ x: 0, y: 0 });
  const [cropFrame, setCropFrame] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [isDraggingFile, setIsDraggingFile] = useState(false);
  const fileInputRef = useRef(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [showImageUpload, setShowImageUpload] = useState(false);
  const [redirect_to_linkedin, setRedirectToLinkedin] = useState(false);
  const [showGenderSelection, setShowGenderSelection] = useState(false);
  const [showFeedbackScreen, setShowFeedbackScreen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [deliveryCities, setDeliveryCities] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [useGoogleSearch, setUseGoogleSearch] = useState(true); // Checked by default
  const [isSearching, setIsSearching] = useState(false);
  const [isSelectingAddress, setIsSelectingAddress] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchTimeoutRef = useRef(null);
  const [customerId, setCustomerId] = useState(null);

  const inputAddressLine1Ref = useRef(null);
  const isBulkRedemption = deliveryCities.length > 0;
  const selectedCity = deliveryCities.find(
    (city) => String(city.location_id) === String(selectedLocationId),
  );
  const isOfficeCity = selectedCity?.city_type === "bulk";
  const showHomeAddress =
    !showOnlyEmail &&
    (!isBulkRedemption || selectedCity?.city_type === "remote");
  const showRecipientForm = !isBulkRedemption || !!selectedLocationId;

  const openPopup = (url) => {
    setPopupImageUrl(url);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupImageUrl("");
  };

  useEffect(() => {
    setLoading(true);
    setErrors({});
    if (token === null || token === "" || token === undefined) {
      setLoading(false);
      navigate("/");
      return;
    }

    if (!state || !selectedPack || !swagpacks) {
      navigate("/");
      return;
    }

    getTemplateIdFromCoupon();
    updateUiWithSelectedPack();
    getCouponItems();
  }, []);

  // Handle click outside to close suggestions dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown) {
        // Check if clicked element is part of the search container or dropdown
        const isSearchInput = event.target.classList.contains(
          "google-places-input",
        );
        const isSearchContainer = event.target.classList.contains(
          "google-search-container",
        );
        const isSuggestionItem = event.target.closest(
          ".google-places-suggestions",
        );

        if (!isSearchInput && !isSearchContainer && !isSuggestionItem) {
          setShowDropdown(false);
        }
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && showDropdown) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [showDropdown]);

  function getTemplateIdFromCoupon() {
    getTemplateData()
      .then((e) => {
        setRedemptionData({
          backgroundColor:
            e.data.result.pageBackgroundColor || e.data.page_background_color,
          logoImageUrl:
            e.data.result.logo_image_url || e.data.result.logoImageUrl,
          buttonColor: e.data.result.buttonColor || e.data.result.buttonColor,
          logoImage: e.data.result.logo_image_url,
          footerColor: e.data.result.footer_color || "",
          headerColor: e.data.result.header_color || "",
          footerText: e.data.result.footer_text || "",
          customerId: e.data.result.customer_id ?? null,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function updateUiWithSelectedPack() {
    if (swagpacks && swagpacks.length > 0) {
      let packIds = swagpacks.map((swagpack) => swagpack.id);
      setSwagpackIds(packIds);
    } else {
      setSwagpackIds(-1);
    }

    const flattened = (swagpacks || []).flatMap((swagpack) =>
      (swagpack.products || []).map((product) => ({
        ...product,
        pack_id: product.pack_id ?? swagpack.id,
      })),
    );
    setProducts(flattened);

    const extractedVariants = flattened.map((product) => product.variants);
    setFilteredVariants(extractedVariants);

    const seeded = new Map();
    flattened.forEach((product, index) => {
      const uniqueId = getVariantKey(product, index);
      if (product?.variants?.length === 1) {
        seeded.set(uniqueId, product.variants[0].title);
      }
    });
    if (seeded.size > 0) {
      setVariants(seeded);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    const variantsArray = products.map((product, index) => {
      const uniqueId = getVariantKey(product, index);
      const selectedVariant = variants.get(uniqueId);
      const matchedVariant = product?.variants?.find(
        (variant) => variant.title === selectedVariant,
      );
      if (selectedVariant && selectedVariant !== "") {
        return {
          product_name: product.product_name,
          product_id: product.product_id,
          size: selectedVariant,
          sku: matchedVariant?.sku,
          pack_id: product.pack_id,
        };
      }
    });

    const cleanedVariants = (variantsArray || []).filter(Boolean);

    if (
      showHomeAddress &&
      customerId &&
      Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
    ) {
      address.city = "Bangalore";
      address.state = "Karnataka";
      address.country = "India";
    }
    const validationResult = validateForm(address);
    if (validationResult.isValid) {
      const phoneWithCountryCode =
        address.calling_code && address.phone
          ? `${address.calling_code}${address.phone.replace(/\s/g, "")}`
          : address.phone;

      const formData = {
        ...address,
        phone: phoneWithCountryCode,
        selected_variants:
          cleanedVariants.length > 0 ? cleanedVariants : undefined,
        pack_ids: swagpackIds,
        campaign_id: campaignId,
        token,
        image_url: uploadedImageUrl,
      };
      if (isBulkRedemption && selectedLocationId) {
        formData.location_id = Number(selectedLocationId);
      }
      if (isOfficeCity) {
        formData.address1 = "";
        formData.address2 = "";
        formData.address3 = "";
        formData.landmark = "";
        formData.city = "";
        formData.state = "";
        formData.country = "";
        formData.pincode = "";
      }
      postData(formData);
    } else {
      if (validationResult.firstErrorField) {
        setTimeout(() => {
          const errorField = document.querySelector(
            `[name="${validationResult.firstErrorField}"]`,
          );
          if (errorField) {
            errorField.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            if (
              errorField.tagName === "INPUT" ||
              errorField.tagName === "SELECT" ||
              errorField.tagName === "TEXTAREA"
            ) {
              setTimeout(() => {
                errorField.focus();
              }, 300);
            }
          }
        }, 100);
      }
    }
  }

  const handleSizeChange = (product, selectedSize, productIndex) => {
    const uniqueId = getVariantKey(product, productIndex);

    setVariants((prevMap) => {
      const next = new Map(prevMap);
      next.set(uniqueId, selectedSize);
      return next;
    });
  };

  const handleClearAll = () => {
    setAddress({
      first_name: "",
      last_name: "",
      email: "",
      emp_id: -1,
      calling_code: "+91",
      phone: "",
      address1: "",
      address2: "",
      address3: "",
      landmark: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      gender: "",
      size: "",
      image_url: "",
    });
    setVariants(new Map());
    setErrors({});
    setUploadedImageUrl("");
    setCaricaturePreview(null);
    setSelectedLocationId(
      deliveryCities.length === 1 ? String(deliveryCities[0].location_id) : "",
    );
  };

  function handleLocationChange(evt) {
    const value = evt.target.value;
    setSelectedLocationId(value);
    setErrors((prevErrors) => {
      const next = { ...prevErrors };
      delete next.location_id;
      return next;
    });
  }

  function applyCitiesFromCoupon(result) {
    const cities = Array.isArray(result?.cities) ? result.cities : [];
    const isBulk = result?.type === "bulk" && cities.length > 0;
    const nextCities = isBulk ? cities : [];
    setDeliveryCities(nextCities);
    setSelectedLocationId(
      nextCities.length === 1 ? String(nextCities[0].location_id) : "",
    );
  }

  function renderCitySelect() {
    if (!isBulkRedemption) return null;

    const isSingleCity = deliveryCities.length === 1;

    return (
      <div className="redemption-form-section">
        <div className="redemption-form-group">
          <label className="redemption-form-label">
            Choose Delivery Location
            <span className="redemption-form-required">*</span>
          </label>
          {isSingleCity ? (
            <input
              type="text"
              className="redemption-form-input"
              name="location_id"
              value={deliveryCities[0].name || ""}
              disabled
              readOnly
            />
          ) : (
            <select
              name="location_id"
              className={`redemption-form-select ${
                errors.location_id ? "error" : ""
              }`}
              value={selectedLocationId}
              onChange={handleLocationChange}
              style={{
                fontSize: "14px",
                color: !selectedLocationId ? "#6c757d" : "#161619",
                backgroundColor: "#F8F9FA",
              }}
            >
              <option value="" style={{ fontSize: "14px", color: "#6c757d" }}>
                Select city
              </option>
              {deliveryCities.map((city) => (
                <option
                  key={city.location_id}
                  value={String(city.location_id)}
                  style={{ color: "#161619" }}
                >
                  {city.name}
                </option>
              ))}
            </select>
          )}
          {errors.location_id && (
            <span className="error-message">{errors.location_id}</span>
          )}
        </div>
      </div>
    );
  }

  async function postData(formData) {
    if (token === "guidewirec0c51933a0bc49228a219d3836070246") {
      formData.country = "India";
    }

    setLoading(true);

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL}/v5/orders/users/coupon/${token}/user-details`,
        formData,
      );
      if (res.data.success) {
        // if onelink request id is present, then set it to the state
        if (res?.data?.result?.onelink_request_id) {
          setOnelinkRequestId(res.data.result.onelink_request_id);
        }

        setLoading(false);
        setModalType("success");
        setModalShown(true); // Show success modal
      } else {
        setLoading(false);
        setModalType("failure");
        setModalShown(true); // Show failure modal
      }
    } catch (err) {
      setLoading(false);
      setModalType("failure");
      setModalShown(true); // Show failure modal
    }
  }

  // Dummy API call function for Google search backend integration
  const searchAddressFromBackend = async (searchQuery) => {
    try {
      setIsSearching(true);
      if (
        customerId &&
        Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
      ) {
        searchQuery = `query=${searchQuery}&lat=12.9629&lng=77.5775`;
      } else {
        searchQuery = `query=${searchQuery}`;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/v5/google/maps/search?${searchQuery}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.success) {
        const results = response.data.result || [];
        setSuggestions(results);
        setShowDropdown(results.length > 0);
        return response.data;
      } else {
        setSuggestions([]);
        setShowDropdown(false);
        return null;
      }
    } catch (error) {
      setSuggestions([]);
      setShowDropdown(false);
      return null;
    } finally {
      setIsSearching(false);
    }
  };

  // Handle address selection from search results
  const handleAddressSelection = async (selectedAddress) => {
    // Prevent multiple selections
    if (isSelectingAddress) return;

    setIsSelectingAddress(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/v5/google/maps/formatted-address?place_id=${selectedAddress.place_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.success) {
        const addressData = response.data.result;
        setAddress((prev) => ({
          ...prev,
          city: addressData.city || "",
          state: addressData.state || "",
          country: addressData.country || "",
          pincode: addressData.pincode || "",
          address2: addressData.address_line || "",
        }));

        setSearchValue("");
        setSuggestions([]);
        setShowDropdown(false);

        inputAddressLine1Ref.current?.focus();

        return response.data;
      } else {
        toast.error("Failed to get address details. Please try again.");
        return null;
      }
    } catch (error) {
      toast.error("Error getting address details. Please try again.");
      return null;
    } finally {
      setIsSelectingAddress(false);
    }
  };

  // Handle search input change with debouncing
  const handleSearchChange = (value) => {
    setSearchValue(value);

    // Clear suggestions if input is empty
    if (!value.trim()) {
      setSuggestions([]);
      setShowDropdown(false);
      setIsSearching(false);
      return;
    }

    if (value.length < 4) {
      setSuggestions([]);
      setShowDropdown(false);
      setIsSearching(false);
      return;
    }

    // Debounce API calls (wait 300ms after user stops typing)
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      if (useGoogleSearch && value.trim()) {
        searchAddressFromBackend(value.trim());
      }
    }, 1000);
  };

  function validateForm(data) {
    const validationErrors = {};
    let firstErrorField = null;

    const addError = (field, message) => {
      validationErrors[field] = message;
      if (!firstErrorField) firstErrorField = field;
    };

    // Recipient Details Section
    if (!data.first_name?.trim()) {
      addError("first_name", "First name is required");
    } else if (data.first_name.length < 2) {
      addError("first_name", "First name must be at least 2 characters");
    }

    if (isBulkRedemption && !selectedLocationId) {
      addError("location_id", "Please select a city");
    }

    if (!data.last_name?.trim()) {
      addError("last_name", "Last name is required");
    }

    if (showOnlyEmail) {
      if (!data.email?.trim()) {
        addError("email", "Email is required");
      } else if (!/\S+@\S+\.\S+/.test(data.email)) {
        addError("email", "Please enter a valid email address");
      }

      if (data.phone?.trim()) {
        if (!data.calling_code?.trim()) {
          addError("calling_code", "Country code is required");
        }
        const cleanPhone = data.phone.replace(/[\s\-()]/g, "");
        if (data.calling_code?.trim() === "+91") {
          if (cleanPhone.length !== 10) {
            addError("phone", "Mobile number must be exactly 10 digits");
          } else if (!/^[6-9]/.test(cleanPhone)) {
            addError("phone", "Mobile number must start with 6, 7, 8, or 9");
          } else if (!/^[6-9][0-9]{9}$/.test(cleanPhone)) {
            addError("phone", "Please enter a valid mobile number");
          }
        } else if (
          cleanPhone.length < 7 ||
          cleanPhone.length > 15 ||
          !/^[0-9]+$/.test(cleanPhone)
        ) {
          addError("phone", "Please enter a valid mobile number");
        }
      }

      // Additional Details Section
      if (showGenderSelection && !data.gender?.trim()) {
        addError("gender", "Please select a gender");
      }

      // Image Upload validation only if showImageUpload is true
      if (showImageUpload && !data.image_url.trim()) {
        addError("image_url", "Please upload an image");
      }
    } else {
      // Gender validation only if showGenderSelection is true
      if (showGenderSelection && (!data.gender || data.gender.trim() === "")) {
        addError("gender", "Please select your gender");
      }

      const phoneRequired = showHomeAddress;
      const hasPhone = !!data.phone?.trim();

      if (phoneRequired || hasPhone) {
        if (!data.calling_code?.trim()) {
          addError("calling_code", "Country code is required");
        }
      }

      if (phoneRequired && !hasPhone) {
        addError("phone", "Phone number is required");
      } else if (hasPhone) {
        const cleanPhone = data.phone.replace(/[\s\-()]/g, "");

        if (data.calling_code?.trim() === "+91") {
          if (cleanPhone.length !== 10) {
            addError("phone", "Mobile number must be exactly 10 digits");
          } else if (!/^[6-9]/.test(cleanPhone)) {
            addError("phone", "Mobile number must start with 6, 7, 8, or 9");
          } else if (!/^[6-9][0-9]{9}$/.test(cleanPhone)) {
            addError("phone", "Please enter a valid mobile number");
          }
        } else {
          if (
            cleanPhone.length < 7 ||
            cleanPhone.length > 15 ||
            !/^[0-9]+$/.test(cleanPhone)
          ) {
            addError("phone", "Please enter a valid mobile number");
          }
        }
      }

      if (!data.email?.trim()) {
        addError("email", "Email is required");
      } else if (!/\S+@\S+\.\S+/.test(data.email)) {
        addError("email", "Please enter a valid email address");
      }

      if (showHomeAddress) {
        if (!data.city?.trim()) {
          addError("city", "City is required");
        } else if (data.city.length < 3) {
          addError("city", "City must be at least 3 characters");
        }

        if (!data.state?.trim()) {
          addError("state", "State is required");
        }

        if (!data.country?.trim()) {
          addError("country", "Country is required");
        }

        if (!data.pincode?.trim()) {
          addError("pincode", "Pincode is required");
        } else if (
          data.pincode.length < 4 ||
          !/^[a-zA-Z0-9\- ]{4,10}$/.test(data.pincode)
        ) {
          addError("pincode", "Please enter a valid pincode");
        }

        if (!data.address1?.trim()) {
          addError("address1", "Address line 1 is required");
        } else if (data.address1.length < 4) {
          addError("address1", "Address must be at least 4 characters");
        }

        if (!data.landmark?.trim()) {
          addError("landmark", "Landmark is required");
        } else if (data.landmark.length < 4) {
          addError("landmark", "Landmark must be at least 4 characters");
        }
      }

      // Additional Details Section
      if (showGenderSelection && !data.gender?.trim()) {
        addError("gender", "Please select a gender");
      }
      // Image Upload validation only if showImageUpload is true
      if (showImageUpload && !data?.image_url && !data?.image_url?.trim()) {
        addError("image_url", "Please upload an image");
      }
    }

    setErrors(validationErrors);
    const isValid = Object.keys(validationErrors).length === 0;
    return { isValid, firstErrorField };
  }

  function capitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function handleChange(evt) {
    const name = evt.target.name;
    const value = evt.target.value;

    setAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));

    // Clear error for this field when it has a value
    if (value && value.trim() !== "") {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  }

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingFile(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingFile(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingFile(false);

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileSelected(files[0]);
    }
  };

  const handleFileSelected = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImageSrc(reader.result);
        setShowUploadPopup(false);
        setShowCropPopup(true);
      });
      reader.readAsDataURL(file);
    }
  };

  const handleUploadComplete = () => {
    handleCropComplete();
    setShowCropPopup(false);
  };

  const CROP_SIZE = 600; // Fixed size in pixels

  const initializeCrop = (img) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Fixed dimensions for the canvas - make it larger to accommodate 600x600
    const CANVAS_MAX_WIDTH = 1000;
    const CANVAS_MAX_HEIGHT = 800;

    let canvasWidth, canvasHeight;
    const imageAspectRatio = img.width / img.height;

    if (imageAspectRatio > CANVAS_MAX_WIDTH / CANVAS_MAX_HEIGHT) {
      canvasWidth = CANVAS_MAX_WIDTH;
      canvasHeight = CANVAS_MAX_WIDTH / imageAspectRatio;
    } else {
      canvasHeight = CANVAS_MAX_HEIGHT;
      canvasWidth = CANVAS_MAX_HEIGHT * imageAspectRatio;
    }

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // Center the crop frame
    const frameX = (canvasWidth - CROP_SIZE) / 2;
    const frameY = (canvasHeight - CROP_SIZE) / 2;

    setCropFrame({
      x: frameX,
      y: frameY,
      width: CROP_SIZE,
      height: CROP_SIZE,
    });

    drawCropOverlay();
  };

  const drawCropOverlay = () => {
    const canvas = canvasRef.current;
    if (!canvas || !imageRef.current) return;

    const ctx = canvas.getContext("2d");
    const { x, y, width, height } = cropFrame;

    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw the original image
    ctx.drawImage(imageRef.current, 0, 0, canvas.width, canvas.height);

    // Create the dark overlay
    ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
    ctx.beginPath();
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.rect(x, y, width, height);
    ctx.fill("evenodd");

    // Draw crop frame border
    ctx.strokeStyle = "#d7458f";
    ctx.lineWidth = 2;
    ctx.strokeRect(x, y, width, height);

    // Draw grid lines
    ctx.strokeStyle = "rgba(255, 255, 255, 0.5)";
    ctx.lineWidth = 1;

    // Vertical lines
    for (let i = 1; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(x + (width * i) / 3, y);
      ctx.lineTo(x + (width * i) / 3, y + height);
      ctx.stroke();
    }

    // Horizontal lines
    for (let i = 1; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(x, y + (height * i) / 3);
      ctx.lineTo(x + width, y + (height * i) / 3);
      ctx.stroke();
    }

    // Add size indicator text
    ctx.fillStyle = "white";
    ctx.font = "12px Arial";
    ctx.textAlign = "center";
    ctx.fillText("600 × 600 px", x + width / 2, y - 10);
  };

  const handleMouseDown = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);

    // Check if click is inside crop frame
    if (
      x >= cropFrame.x &&
      x <= cropFrame.x + cropFrame.width &&
      y >= cropFrame.y &&
      y <= cropFrame.y + cropFrame.height
    ) {
      setIsDragging(true);
      setStartPoint({ x: x - cropFrame.x, y: y - cropFrame.y });
      e.preventDefault();
    }
  };

  const handleMouseMove = (e) => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);

    // Update cursor based on position
    if (!isDragging) {
      if (
        x >= cropFrame.x &&
        x <= cropFrame.x + cropFrame.width &&
        y >= cropFrame.y &&
        y <= cropFrame.y + cropFrame.height
      ) {
        canvas.style.cursor = "move";
      } else {
        canvas.style.cursor = "default";
      }
    }

    if (isDragging) {
      e.preventDefault();
      let newX = x - startPoint.x;
      let newY = y - startPoint.y;

      // Keep crop frame within canvas bounds
      newX = Math.max(0, Math.min(newX, canvas.width - cropFrame.width));
      newY = Math.max(0, Math.min(newY, canvas.height - cropFrame.height));

      setCropFrame((prev) => ({
        ...prev,
        x: newX,
        y: newY,
      }));

      drawCropOverlay();
    }
  };

  const handleMouseUp = (e) => {
    if (isDragging) {
      e.preventDefault();
    }
    setIsDragging(false);
    canvasRef.current.style.cursor = "default";
  };

  const uploadImage = async (image) => {
    try {
      const formData = new FormData();
      formData.append("file", image); // send it as a File
      formData.append("container", "redemption-images");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/v5/images/user/single`,
        formData,
      );
      if (response.data.success) {
        return response.data.result;
      }
    } catch (error) {
      toast.error("Failed to upload image. Please try again.");
    }
  };

  const handleCropComplete = () => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Set the output canvas to exactly 600x600
    canvas.width = 600;
    canvas.height = 600;

    // Calculate the scale factors
    const displayCanvas = canvasRef.current;
    const scaleX = imageRef.current.width / displayCanvas.width;
    const scaleY = imageRef.current.height / displayCanvas.height;

    // Calculate the actual crop coordinates in the original image
    const sourceX = cropFrame.x * scaleX;
    const sourceY = cropFrame.y * scaleY;
    const sourceWidth = cropFrame.width * scaleX;
    const sourceHeight = cropFrame.height * scaleY;

    // Draw the cropped portion of the original image onto the new canvas
    ctx.drawImage(
      imageRef.current,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight, // Source rectangle
      0,
      0,
      600,
      600, // Destination rectangle
    );

    // Convert to blob with better quality
    canvas.toBlob(
      async (blob) => {
        try {
          const file = new File([blob], "cropped-image.jpg", {
            type: "image/jpeg",
          });

          const awsUrl = await uploadImage(file);
          setUploadedImageUrl(awsUrl);
          setAddress((prev) => ({
            ...prev,
            image_url: awsUrl,
          }));
          setErrors((prev) => {
            if (!prev.image_url) return prev;
            const updated = { ...prev };
            delete updated.image_url;
            return updated;
          });

          // Create a local preview URL from the blob
          const previewUrl = URL.createObjectURL(blob);
          setCaricaturePreview(previewUrl);

          setShowCropPopup(false);
          setImageSrc(null);
        } catch (error) {}
      },
      "image/jpeg",
      1.0, // Maximum quality
    );
  };

  useEffect(() => {
    if (imageSrc && showCropPopup && canvasRef.current) {
      const img = new Image();

      img.onload = () => {
        imageRef.current = img;
        initializeCrop(img);
      };

      img.src = imageSrc;
    }
  }, [imageSrc, showCropPopup]);

  // Add an effect to ensure crop frame is always visible
  useEffect(() => {
    if (showCropPopup && imageRef.current && canvasRef.current) {
      drawCropOverlay();
    }
  }, [showCropPopup, cropFrame]);

  function Modal({ children, shown, close }) {
    if (!shown) {
      return null;
    }

    return (
      <div
        className="modal-backdrop"
        onClick={close}
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "auto",
            maxWidth: "350px",
            backgroundColor: "white",
            padding: "25px",
            borderRadius: "15px",
            position: "relative",
          }}
        >
          {children}
          <button
            onClick={close}
            style={{
              marginTop: "20px",
              padding: "8px 16px",
              border: "none",
              fontSize: "17px",
              fontWeight: "600",
              backgroundColor: "#6455ED",
              color: "white",
              borderRadius: "8px",
              width: "40%",
              margin: "0 auto",
              cursor: "pointer",
            }}
          >
            Okay
          </button>
        </div>
      </div>
    );
  }

  function getCustomerConfig() {
    axios
      .get(
        `${process.env.REACT_APP_URL}/v5/customers/${customerId}/config/redemption`,
      )
      .then((res) => {
        if (res.data.success && res.data.result) {
          setRedirectToLinkedin(
            Boolean(Number(res.data.result.redirect_redemptions_to_linkedin)),
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        navigate({
          pathname: "/",
          search: `?${createSearchParams(params)}`,
        });
      });
  }

  function getCouponItems() {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_URL}/v4/customer/redemption/couponItems?token=${token}`,
      )
      .then((res) => {
        if (res.data.success && res.data.result) {
          setCampaignId(
            res.data.result.campaign_id
              ? Number(res.data.result.campaign_id)
              : null,
          );
          setShowImageUpload(
            Boolean(Number(res.data.result.show_image_upload)),
          );
          setShowGenderSelection(
            Boolean(Number(res.data.result.show_gender_selection)),
          );
          setShowFeedbackScreen(
            Boolean(Number(res.data.result.show_feedback_screen)),
          );
          setRedirectToLinkedin(
            Boolean(
              Number(
                res.data.result.customer_config
                  .redirect_redemptions_to_linkedin,
              ),
            ),
          );
          if (
            res.data.result.swagpacks &&
            res.data.result.swagpacks.length > 0
          ) {
            setShowOnlyEmail(res.data.result.email_only);
            setCustomerId(res.data.result.customer_id);
            applyCitiesFromCoupon(res.data.result);

            // getCustomerConfig();
          } else {
            setLoading(false);
            navigate({
              pathname: "/",
              search: `?${createSearchParams(params)}`,
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        navigate({
          pathname: "/",
          search: `?${createSearchParams(params)}`,
        });
      });
  }

  const handleModalClose = () => {
    setModalShown(false);

    if (modalType === "failure") {
      return;
    }

    if (modalType === "success" && showFeedbackScreen) {
      navigate(
        `/redemption/feedback?token=${params.token}&onelink_request_id=${onelinkRequestId}`,
      );
    } else if (modalType === "success") {
      if (
        customerId &&
        Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
      ) {
        navigate(`/redemption/thank-you`);
        return;
      } else {
        if (redirect_to_linkedin) {
          window.location.href = "https://www.linkedin.com/company/swageazy";
        } else {
          navigate(`/redemption/thank-you`);
        }
      }
    }
  };

  // // New GradientHeader component
  // const GradientHeader = ({ logoSrc }) => {
  //   const [imgError, setImgError] = useState(false);
  //   const [logoStyle, setLogoStyle] = useState({
  //     height: "auto",
  //     width: "auto",
  //     maxHeight: "100px",
  //     maxWidth: "150px",
  //     width: "auto",
  //     height: "auto",
  //     objectFit: "contain",
  //     marginRight: "60px",
  //   });

  //   const checkLogoVisibility = (src, error) => {
  //     return src && src !== "" && src !== "null" && !error;
  //   };

  //   const handleImageLoad = (e) => {
  //     const img = e.target;
  //     const aspectRatio = img.naturalWidth / img.naturalHeight;
  //     const viewportWidth = window.innerWidth;

  //     // Base sizes that will be adjusted by screen width
  //     let baseMaxWidth = 150;
  //     let baseMaxHeight = 80;
  //     let marginRight = "60px"; // Default margin

  //     // Adjust margin for small screens
  //     if (viewportWidth < 576) {
  //       marginRight = "15px";
  //     }

  //     // Adjust base sizes according to viewport width
  //     if (viewportWidth >= 1880) {
  //       baseMaxWidth = 180;
  //       baseMaxHeight = 80;
  //     } else if (viewportWidth >= 1280) {
  //       baseMaxWidth = 155;
  //       baseMaxHeight = 75;
  //     } else if (viewportWidth < 768) {
  //       baseMaxWidth = 120;
  //       baseMaxHeight = 50;
  //     } else if (viewportWidth < 400) {
  //       baseMaxWidth = 80;
  //       baseMaxHeight = 40;
  //     }

  //     // Then adjust for aspect ratio
  //     if (aspectRatio > 2) {
  //       setLogoStyle((prev) => ({
  //         ...prev,
  //         maxWidth: `${baseMaxWidth * 1.2}px`, // 20% wider for wide logos
  //         maxHeight: `${baseMaxHeight * 0.9}px`, // Slightly shorter
  //         marginRight: marginRight,
  //       }));
  //     } else if (aspectRatio < 0.5) {
  //       setLogoStyle((prev) => ({
  //         ...prev,
  //         maxWidth: `${baseMaxWidth * 0.7}px`, // Narrower for tall logos
  //         maxHeight: `${baseMaxHeight}px`,
  //         marginRight: marginRight,
  //       }));
  //     } else {
  //       // Regular aspect ratio
  //       setLogoStyle((prev) => ({
  //         ...prev,
  //         maxWidth: `${baseMaxWidth}px`,
  //         maxHeight: `${baseMaxHeight}px`,
  //         marginRight: marginRight,
  //       }));
  //     }
  //   };

  //   // Add resize listener
  //   useEffect(() => {
  //     const handleResize = () => {
  //       // Trigger handleImageLoad again on resize
  //       const img = document.querySelector(".theme-logo-image");
  //       if (img) {
  //         handleImageLoad({ target: img });
  //       }
  //     };

  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  //   }, []);

  //   if (!checkLogoVisibility(logoSrc, imgError)) return null;

  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         padding: "24px 0",
  //         // background:"linear-gradient(to bottom, #1e1665 0%, rgba(58,94,255,0) 100%)",
  //         display: "flex",
  //         justifyContent: "flex-end",
  //         alignItems: "center",
  //       }}
  //     >
  //       <img
  //         className="img-fluid theme-logo-image"
  //         src={logoSrc}
  //         alt="Logo"
  //         style={logoStyle}
  //         onError={() => setImgError(true)}
  //         onLoad={handleImageLoad}
  //       />
  //     </div>
  //   );
  // };

  return (
    <div className="bg-white redemption-form-page">
      {loading ? (
        <div className="loading-indicator-admin"> </div>
      ) : (
        <div className="redemption-form-page-inner">
          <div className="row pb-3 d-flex mb-4">
            <div
              className="col-12 mb-4 p-0 position-relative"
              style={{ height: "25vh" }}
            >
              <div
                className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0"
                style={{
                  zIndex: 1000,
                  position: "absolute",
                }}
              >
                {redemptionData.logoImage && (
                  <div className="d-flex">
                    <GradientHeader
                      logoSrc={redemptionData.logoImage}
                      headerColor={redemptionData.headerColor}
                      justifyContent="flex-end"
                    />
                  </div>
                )}
              </div>
              <img
                src={
                  "https://content.swageazy.com/website/Redeem-address-img_1751892708580.webp"
                }
                alt="Gift boxes"
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div
                className="position-absolute"
                style={{
                  top: "60%",
                  transform: "translateY(-50%)",
                  left: "10%",
                  color: "white",
                }}
              >
                <p className="redemption-form-page-title">
                  Let us know where to deliver
                </p>
                <p className="redemption-form-page-subtitle">
                  Just a few details to make sure your gift reaches you.
                </p>
              </div>
            </div>
            <div className="col-12 form-outer-container">
              {!showOnlyEmail && (
                <>
                  <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-10 col-md-10 col-lg-8 col-xl-8 col-xxl-8 redemption-form-container">
                      {renderCitySelect()}
                      {showRecipientForm && (
                        <>
                          <div className="redemption-form-section">
                            <h2 className="redemption-form-section-title">
                              Recipient details
                            </h2>
                            <div className="row g-4">
                              {showGenderSelection ? (
                                <>
                                  <div className="col-md-4">
                                    <label className="redemption-form-label">
                                      First name
                                      <span className="redemption-form-required">
                                        *
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`redemption-form-input ${
                                        errors.first_name ? "error" : ""
                                      }`}
                                      placeholder="Enter your First name"
                                      name="first_name"
                                      onChange={handleChange}
                                      value={address.first_name}
                                    />
                                    {errors.first_name && (
                                      <span className="error-message">
                                        {errors.first_name}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="redemption-form-label">
                                      Last name
                                      <span className="redemption-form-required">
                                        *
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`redemption-form-input ${
                                        errors.last_name ? "error" : ""
                                      }`}
                                      placeholder="Enter your Last name"
                                      name="last_name"
                                      onChange={handleChange}
                                      value={address.last_name}
                                    />
                                    {errors.last_name && (
                                      <span className="error-message">
                                        {errors.last_name}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="redemption-form-label">
                                      Gender
                                      <span className="redemption-form-required">
                                        *
                                      </span>
                                    </label>
                                    <select
                                      id="gender"
                                      name="gender"
                                      className={`redemption-form-select ${
                                        errors.gender ? "error" : ""
                                      }`}
                                      onChange={handleChange}
                                      value={address.gender || ""}
                                      style={{
                                        fontSize: "14px",
                                        color: !address.gender
                                          ? "#6c757d"
                                          : "#161619",
                                        backgroundColor: "#F8F9FA",
                                      }}
                                    >
                                      <option
                                        value=""
                                        style={{
                                          fontSize: "14px",
                                          color: "#6c757d",
                                        }}
                                      >
                                        Enter your Gender
                                      </option>
                                      <option
                                        value="male"
                                        style={{ color: "#161619" }}
                                      >
                                        Male
                                      </option>
                                      <option
                                        value="female"
                                        style={{ color: "#161619" }}
                                      >
                                        Female
                                      </option>
                                    </select>
                                    {errors.gender && (
                                      <span className="error-message">
                                        {errors.gender}
                                      </span>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="col-md-6">
                                    <label className="redemption-form-label">
                                      First name
                                      <span className="redemption-form-required">
                                        *
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`redemption-form-input ${
                                        errors.first_name ? "error" : ""
                                      }`}
                                      placeholder="Enter your First name"
                                      name="first_name"
                                      onChange={handleChange}
                                      value={address.first_name}
                                    />
                                    {errors.first_name && (
                                      <span className="error-message">
                                        {errors.first_name}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-md-6">
                                    <label className="redemption-form-label">
                                      Last name
                                      <span className="redemption-form-required">
                                        *
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`redemption-form-input ${
                                        errors.last_name ? "error" : ""
                                      }`}
                                      placeholder="Enter your Last name"
                                      name="last_name"
                                      onChange={handleChange}
                                      value={address.last_name}
                                    />
                                    {errors.last_name && (
                                      <span className="error-message">
                                        {errors.last_name}
                                      </span>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="row g-4 mt-1">
                              <div className="col-md-6">
                                <label className="redemption-form-label">
                                  Contact number{" "}
                                  {showHomeAddress ? (
                                    <>
                                      <span className="redemption-form-helper-text-inline">
                                        (Country code is mandatory)
                                      </span>
                                      <span className="redemption-form-required">
                                        *
                                      </span>
                                    </>
                                  ) : (
                                    <span className="redemption-form-helper-text-inline">
                                      (optional)
                                    </span>
                                  )}
                                </label>
                                <div className="phone-input-container">
                                  <div className="phone-country-code-wrapper">
                                    <input
                                      type="text"
                                      className={`redemption-form-input phone-country-code ${
                                        errors.calling_code ? "error" : ""
                                      }`}
                                      placeholder="+91"
                                      name="calling_code"
                                      onChange={handleChange}
                                      value={address.calling_code}
                                    />
                                    {errors.calling_code && (
                                      <span className="error-message phone-inline-error">
                                        {errors.calling_code}
                                      </span>
                                    )}
                                  </div>
                                  <div className="phone-number-wrapper">
                                    <input
                                      type="text"
                                      className={`redemption-form-input phone-number ${
                                        errors.phone ? "error" : ""
                                      }`}
                                      placeholder="892xxxxx91"
                                      name="phone"
                                      onChange={handleChange}
                                      value={address.phone}
                                    />
                                    {errors.phone && (
                                      <span className="error-message phone-inline-error">
                                        {errors.phone}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <label className="redemption-form-label">
                                  Email address
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="email"
                                  className={`redemption-form-input ${
                                    errors.email ? "error" : ""
                                  }`}
                                  placeholder="e.g., name@company.com"
                                  name="email"
                                  onChange={handleChange}
                                  value={address.email}
                                />
                                {errors.email && (
                                  <span className="error-message">
                                    {errors.email}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {showHomeAddress && (
                            <div className="redemption-form-section ">
                              <div className="d-flex gap-3 flex-wrap align-items-center mb-3">
                                {customerId &&
                                Number(customerId) ===
                                  Number(process.env.REACT_APP_CUSTOMER_ID) ? (
                                  <h2 className="redemption-form-section-title mb-0">
                                    Address details (Bangalore Addresses Only)
                                  </h2>
                                ) : (
                                  <h2 className="redemption-form-section-title mb-0">
                                    Address details
                                  </h2>
                                )}
                                <span
                                  className="address-toggle-link"
                                  onClick={() =>
                                    setUseGoogleSearch(!useGoogleSearch)
                                  }
                                >
                                  {useGoogleSearch
                                    ? "Enter address manually"
                                    : "Use address search"}
                                </span>
                              </div>

                              {useGoogleSearch && (
                                <div
                                  className="redemption-form-group mb-4"
                                  style={{ position: "relative" }}
                                >
                                  <label className="redemption-form-label">
                                    Search Address
                                  </label>

                                  <div className="google-search-container">
                                    <input
                                      type="text"
                                      className={`redemption-form-input google-places-input ${
                                        isSearching
                                          ? "google-search-input-loading"
                                          : "google-search-input-normal"
                                      }`}
                                      placeholder="Start typing your address..."
                                      value={searchValue}
                                      onChange={(e) => {
                                        if (useGoogleSearch) {
                                          handleSearchChange(e.target.value);
                                        } else {
                                          setSearchValue(e.target.value);
                                        }
                                      }}
                                      onClick={() => {
                                        if (
                                          useGoogleSearch &&
                                          suggestions.length > 0
                                        ) {
                                          setShowDropdown(true);
                                        }
                                      }}
                                      disabled={!useGoogleSearch}
                                      autoComplete="off"
                                      autoCorrect="off"
                                      autoCapitalize="off"
                                      spellCheck={false}
                                      aria-autocomplete="off"
                                    />
                                    {isSearching && (
                                      <div className="google-search-spinner" />
                                    )}
                                  </div>

                                  {/* Suggestions Dropdown */}
                                  {suggestions.length > 0 &&
                                    useGoogleSearch &&
                                    showDropdown && (
                                      <div className="google-places-suggestions">
                                        {suggestions.map(
                                          (suggestion, index) => (
                                            <div
                                              key={suggestion.id || index}
                                              className={`google-places-suggestion-item ${
                                                isSelectingAddress
                                                  ? "suggestion-item-disabled"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                if (!isSelectingAddress) {
                                                  handleAddressSelection(
                                                    suggestion,
                                                  );
                                                }
                                              }}
                                            >
                                              <div className="google-places-suggestion-title">
                                                {suggestion.name ||
                                                  suggestion.main_text ||
                                                  suggestion.title}
                                              </div>
                                              <div className="google-places-suggestion-address">
                                                {suggestion.formatted_address ||
                                                  suggestion.secondary_text ||
                                                  suggestion.description}
                                              </div>
                                              {isSelectingAddress && (
                                                <div className="google-search-spinner suggestion-spinner" />
                                              )}
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    )}
                                </div>
                              )}

                              <div className="row g-4">
                                <div className="col-md-4">
                                  <label className="redemption-form-label">
                                    City
                                    <span className="redemption-form-required">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`redemption-form-input ${
                                      errors.city ? "error" : ""
                                    }`}
                                    placeholder={
                                      useGoogleSearch
                                        ? "Auto-filled from search"
                                        : "Enter your City"
                                    }
                                    name="city"
                                    onChange={handleChange}
                                    value={
                                      customerId &&
                                      Number(customerId) ===
                                        Number(
                                          process.env.REACT_APP_CUSTOMER_ID,
                                        )
                                        ? "Bangalore"
                                        : address.city
                                    }
                                    disabled={useGoogleSearch}
                                  />
                                  {errors.city && (
                                    <span className="error-message">
                                      {errors.city}
                                    </span>
                                  )}
                                </div>
                                <div className="col-md-4">
                                  <label className="redemption-form-label">
                                    State
                                    <span className="redemption-form-required">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`redemption-form-input ${
                                      errors.state ? "error" : ""
                                    }`}
                                    placeholder={
                                      useGoogleSearch
                                        ? "Auto-filled from search"
                                        : "Enter your State"
                                    }
                                    name="state"
                                    onChange={handleChange}
                                    value={
                                      customerId &&
                                      Number(customerId) ===
                                        Number(
                                          process.env.REACT_APP_CUSTOMER_ID,
                                        )
                                        ? "Karnataka"
                                        : address.state
                                    }
                                    disabled={useGoogleSearch}
                                  />
                                  {errors.state && (
                                    <span className="error-message">
                                      {errors.state}
                                    </span>
                                  )}
                                </div>
                                <div className="col-md-4">
                                  <label className="redemption-form-label">
                                    Country
                                    <span className="redemption-form-required">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`redemption-form-input ${
                                      errors.country ? "error" : ""
                                    }`}
                                    placeholder={
                                      useGoogleSearch
                                        ? "Auto-filled from search"
                                        : "Enter your Country"
                                    }
                                    name="country"
                                    onChange={handleChange}
                                    value={
                                      customerId &&
                                      Number(customerId) ===
                                        Number(
                                          process.env.REACT_APP_CUSTOMER_ID,
                                        )
                                        ? "India"
                                        : address.country
                                    }
                                    disabled={useGoogleSearch}
                                  />
                                  {errors.country && (
                                    <span className="error-message">
                                      {errors.country}
                                    </span>
                                  )}
                                </div>
                              </div>

                              <div className="redemption-form-group">
                                <label className="redemption-form-label">
                                  Pincode / ZIP Code
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  className={`redemption-form-input ${
                                    errors.pincode ? "error" : ""
                                  }`}
                                  placeholder={
                                    useGoogleSearch
                                      ? "Auto-filled from search"
                                      : "e.g. 560001"
                                  }
                                  name="pincode"
                                  onChange={handleChange}
                                  value={address.pincode}
                                  disabled={useGoogleSearch}
                                />
                                {errors.pincode && (
                                  <span className="error-message">
                                    {errors.pincode}
                                  </span>
                                )}
                              </div>

                              <div className="redemption-form-group">
                                <label className="redemption-form-label">
                                  Address line 1
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  ref={inputAddressLine1Ref}
                                  className={`redemption-form-input ${
                                    errors.address1 ? "error" : ""
                                  }`}
                                  placeholder="Please enter House No or Flat/Floor No"
                                  name="address1"
                                  onChange={handleChange}
                                  value={address.address1}
                                />
                                {errors.address1 && (
                                  <span className="error-message">
                                    {errors.address1}
                                  </span>
                                )}
                              </div>

                              <div className="redemption-form-group">
                                <label className="redemption-form-label">
                                  Address line 2
                                </label>
                                <input
                                  type="text"
                                  className="redemption-form-input"
                                  placeholder={
                                    useGoogleSearch
                                      ? "Auto-filled from search"
                                      : "Street name, area, etc."
                                  }
                                  name="address2"
                                  onChange={handleChange}
                                  value={address.address2}
                                  disabled={useGoogleSearch}
                                />
                              </div>

                              <div className="redemption-form-group">
                                <label className="redemption-form-label">
                                  Landmark
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  className={`redemption-form-input ${
                                    errors.landmark ? "error" : ""
                                  }`}
                                  placeholder="Nearby landmark"
                                  name="landmark"
                                  onChange={handleChange}
                                  value={address.landmark}
                                />
                                {errors.landmark && (
                                  <span className="error-message">
                                    {errors.landmark}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                          {products.some(
                            (product) =>
                              product.variants && product.variants.length > 1,
                          ) && (
                            <div className="redemption-form-section">
                              <h2 className="redemption-form-section-title mb-0 pt-2">
                                Please select the size for the product
                              </h2>
                              {products.map(
                                (product, index) =>
                                  product.variants &&
                                  product.variants.length > 1 && (
                                    <div
                                      className="row g-4"
                                      key={index}
                                      style={{
                                        marginTop: index > 0 ? "0rem" : "0",
                                      }}
                                    >
                                      <div className="col-12">
                                        <label className="redemption-form-label">
                                          {`Select the size for ${product.product_name}`}
                                          <span className="redemption-form-required">
                                            *
                                          </span>
                                        </label>
                                        <div className="d-flex align-items-center gap-3">
                                          <SizeVariantSelect
                                            required
                                            id={`sizeDropdown${index}`}
                                            variants={product?.variants || []}
                                            value={
                                              variants.get(
                                                getVariantKey(product, index),
                                              ) || ""
                                            }
                                            onChange={(selectedSize) => {
                                              handleSizeChange(
                                                product,
                                                selectedSize,
                                                index,
                                              );
                                            }}
                                            capitalize={capitalize}
                                            style={{
                                              width: !product.size_chart_url
                                                ? "100%"
                                                : "90%",
                                            }}
                                          />

                                          {product.size_chart_url && (
                                            <span
                                              onClick={() =>
                                                openPopup(
                                                  product.size_chart_url,
                                                )
                                              }
                                              style={{
                                                color: "#6455ED",
                                                textDecoration: "underline",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                                fontWeight: 500,
                                              }}
                                            >
                                              View Size Chart
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ),
                              )}
                            </div>
                          )}

                          {showImageUpload && (
                            <div className="redemption-form-section">
                              <h2 className="redemption-form-section-title">
                                Upload Image
                                <span className="redemption-form-required">
                                  *
                                </span>
                              </h2>
                              <p
                                onClick={() =>
                                  openPopup(
                                    "https://content.swageazy.com/public/sample_image1.jpeg",
                                  )
                                }
                                style={{
                                  color: "#d7458f",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: 600,
                                  fontSize: "0.9rem",
                                  marginBottom: "15px",
                                }}
                              >
                                View Sample Photo
                              </p>
                              <div className="row g-4">
                                <div className=" col-12 col-md-4">
                                  <div
                                    className="upload-container"
                                    onDragEnter={handleDragEnter}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                    onClick={() =>
                                      fileInputRef.current?.click()
                                    }
                                    style={{
                                      border: `4px dashed ${
                                        isDraggingFile ? "#888888" : "#ddd"
                                      }`,
                                      borderRadius: "8px",
                                      padding: "40px 20px",
                                      textAlign: "center",
                                      cursor: "pointer",
                                      minHeight: "200px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      position: "relative",
                                    }}
                                  >
                                    {uploadedImageUrl ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          src={uploadedImageUrl}
                                          alt="Uploaded preview"
                                          style={{
                                            maxWidth: "200px",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            margin: "10px 0",
                                          }}
                                        />
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setUploadedImageUrl("");
                                            setCaricaturePreview(null);
                                            setAddress((prev) => ({
                                              ...prev,
                                              image_url: "",
                                            }));
                                          }}
                                          style={{
                                            position: "absolute",
                                            top: "-10px",
                                            right: "50%",
                                            transform: "translateX(100px)",
                                            background: "#d7458f",
                                            border: "none",
                                            color: "white",
                                            borderRadius: "50%",
                                            width: "24px",
                                            height: "24px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                          }}
                                        >
                                          ×
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        <FontAwesomeIcon
                                          icon={faCloudUpload}
                                          style={{
                                            fontSize: "2.5rem",
                                            color: "#6455ED",
                                            marginBottom: "15px",
                                          }}
                                        />
                                        <div style={{ marginBottom: "10px" }}>
                                          <span style={{ color: "#666" }}>
                                            Drop an Image or{" "}
                                            <span
                                              style={{
                                                color: "#6455ED",
                                                textDecoration: "underline",
                                              }}
                                            >
                                              Browse
                                            </span>
                                          </span>
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "0.8rem",
                                            color: "#999",
                                          }}
                                        >
                                          *Max file size 2 MB
                                        </div>
                                      </>
                                    )}
                                    <input
                                      ref={fileInputRef}
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) =>
                                        handleFileSelected(e.target.files[0])
                                      }
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {errors.image_url && (
                                    <div
                                      className="error-message"
                                      style={{
                                        color: "red",
                                        fontSize: "0.875rem",
                                        marginTop: "0.5rem",
                                      }}
                                    >
                                      {errors.image_url}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="row mt-4 justify-content-center">
                            <div className="col-12 col-md-3 ">
                              <button
                                type="submit"
                                style={{
                                  backgroundColor: "#6455ED",
                                  color: "#fff",
                                  borderRadius: "25px",
                                  border: "none",
                                }}
                                className="btn mt-2 mb-2 w-100"
                              >
                                Submit Details
                              </button>
                            </div>
                            <div className="col-12 col-md-3">
                              <button
                                style={{
                                  backgroundColor: "#fff",
                                  border: "1px solid #D8DEE4",
                                  color: "#161619",
                                  borderRadius: "25px",
                                }}
                                className="btn mt-2 mb-2 w-100"
                                onClick={handleClearAll}
                              >
                                Clear all
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                </>
              )}
              {showOnlyEmail ? (
                <>
                  <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-10 col-md-10 col-lg-8 col-xl-8 col-xxl-8 redemption-form-container">
                      {renderCitySelect()}
                      {showRecipientForm && (
                        <>
                          <div className="redemption-form-section">
                            <h2 className="redemption-form-section-title">
                              Contact details
                            </h2>
                            <div className="row g-4">
                              <div className="col-md-6">
                                <label className="redemption-form-label">
                                  First name
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  className={`redemption-form-input ${
                                    errors.first_name ? "error" : ""
                                  }`}
                                  placeholder="Enter your First name"
                                  name="first_name"
                                  onChange={handleChange}
                                  value={address.first_name}
                                />
                                {errors.first_name && (
                                  <span className="error-message">
                                    {errors.first_name}
                                  </span>
                                )}
                              </div>
                              <div className="col-md-6">
                                <label className="redemption-form-label">
                                  Last name
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  className={`redemption-form-input ${
                                    errors.last_name ? "error" : ""
                                  }`}
                                  placeholder="Enter your Last name"
                                  name="last_name"
                                  onChange={handleChange}
                                  value={address.last_name}
                                />
                                {errors.last_name && (
                                  <span className="error-message">
                                    {errors.last_name}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="row g-4 mt-1">
                              <div className="col-md-6">
                                <label className="redemption-form-label">
                                  Contact number{" "}
                                  <span className="redemption-form-helper-text-inline">
                                    (optional)
                                  </span>
                                </label>
                                <div className="phone-input-container">
                                  <div className="phone-country-code-wrapper">
                                    <input
                                      type="text"
                                      className={`redemption-form-input phone-country-code ${
                                        errors.calling_code ? "error" : ""
                                      }`}
                                      placeholder="+91"
                                      name="calling_code"
                                      onChange={handleChange}
                                      value={address.calling_code}
                                    />
                                    {errors.calling_code && (
                                      <span className="error-message phone-inline-error">
                                        {errors.calling_code}
                                      </span>
                                    )}
                                  </div>
                                  <div className="phone-number-wrapper">
                                    <input
                                      type="text"
                                      className={`redemption-form-input phone-number ${
                                        errors.phone ? "error" : ""
                                      }`}
                                      placeholder="892xxxxx91"
                                      name="phone"
                                      onChange={handleChange}
                                      value={address.phone}
                                    />
                                    {errors.phone && (
                                      <span className="error-message phone-inline-error">
                                        {errors.phone}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <label className="redemption-form-label">
                                  Work Email
                                  <span className="redemption-form-required">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="email"
                                  className={`redemption-form-input ${
                                    errors.email ? "error" : ""
                                  }`}
                                  placeholder="e.g., name@company.com"
                                  onChange={handleChange}
                                  name="email"
                                  value={address.email}
                                />
                                {errors.email && (
                                  <span className="error-message">
                                    {errors.email}
                                  </span>
                                )}
                              </div>
                              {showGenderSelection && (
                                <div className="col-md-6">
                                  <label className="redemption-form-label">
                                    Gender
                                    <span className="redemption-form-required">
                                      *
                                    </span>
                                  </label>
                                  <select
                                    id="gender"
                                    name="gender"
                                    className={`redemption-form-select ${
                                      errors.gender ? "error" : ""
                                    }`}
                                    onChange={handleChange}
                                    value={address.gender || ""}
                                    style={{
                                      fontSize: "14px",
                                      color: !address.gender
                                        ? "#6c757d"
                                        : "#161619",
                                      backgroundColor: "#F8F9FA",
                                    }}
                                  >
                                    <option
                                      value=""
                                      style={{
                                        fontSize: "14px",
                                        color: "#6c757d",
                                      }}
                                    >
                                      Enter your Gender
                                    </option>
                                    <option
                                      value="male"
                                      style={{ color: "#161619" }}
                                    >
                                      Male
                                    </option>
                                    <option
                                      value="female"
                                      style={{ color: "#161619" }}
                                    >
                                      Female
                                    </option>
                                  </select>
                                  {errors.gender && (
                                    <span className="error-message">
                                      {errors.gender}
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>

                            {products.some(
                              (product) =>
                                product.variants && product.variants.length > 1,
                            ) && (
                              <div className="redemption-form-section mt-4">
                                <h2 className="redemption-form-section-title">
                                  Product details
                                </h2>
                              </div>
                            )}
                            {products.map(
                              (product, index) =>
                                product.variants &&
                                product.variants.length > 1 && (
                                  <div
                                    className="redemption-form-section mt-4"
                                    key={index}
                                  >
                                    <div className="row g-4">
                                      <div className="col-12">
                                        <label className="redemption-form-label">
                                          {`Select the size for ${product.product_name}`}
                                          <span className="redemption-form-required">
                                            *
                                          </span>
                                        </label>
                                        <div className="d-flex align-items-center gap-3">
                                          <SizeVariantSelect
                                            required
                                            id={`sizeDropdown${index}`}
                                            variants={product?.variants || []}
                                            value={
                                              variants.get(
                                                getVariantKey(product, index),
                                              ) || ""
                                            }
                                            onChange={(selectedSize) => {
                                              handleSizeChange(
                                                product,
                                                selectedSize,
                                                index,
                                              );
                                            }}
                                            capitalize={capitalize}
                                            style={{
                                              width: !product.size_chart_url
                                                ? "100%"
                                                : "90%",
                                            }}
                                          />

                                          {product.size_chart_url && (
                                            <span
                                              onClick={() =>
                                                openPopup(
                                                  product.size_chart_url,
                                                )
                                              }
                                              style={{
                                                color: "#6455ED",
                                                textDecoration: "underline",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                                fontWeight: 500,
                                              }}
                                            >
                                              View Size Chart
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ),
                            )}
                          </div>

                          {showImageUpload && (
                            <div className="redemption-form-section">
                              <h2 className="redemption-form-section-title">
                                Upload Image
                                <span className="redemption-form-required">
                                  *
                                </span>
                              </h2>
                              <p
                                onClick={() =>
                                  openPopup(
                                    "https://content.swageazy.com/public/sample_image.jpeg",
                                  )
                                }
                                style={{
                                  color: "#d7458f",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: 600,
                                  fontSize: "0.9rem",
                                  marginBottom: "15px",
                                }}
                              >
                                View Sample Photo
                              </p>
                              <div className="row g-4">
                                <div className="col-12">
                                  <div
                                    className="upload-container"
                                    onDragEnter={handleDragEnter}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                    onClick={() =>
                                      fileInputRef.current?.click()
                                    }
                                    style={{
                                      border: `4px dashed ${
                                        isDraggingFile ? "#888888" : "#ddd"
                                      }`,
                                      borderRadius: "8px",
                                      padding: "40px 20px",
                                      textAlign: "center",
                                      cursor: "pointer",
                                      minHeight: "200px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      position: "relative",
                                    }}
                                  >
                                    {uploadedImageUrl ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          src={uploadedImageUrl}
                                          alt="Uploaded preview"
                                          style={{
                                            maxWidth: "200px",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            margin: "10px 0",
                                          }}
                                        />
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setUploadedImageUrl("");
                                            setCaricaturePreview(null);
                                            setAddress((prev) => ({
                                              ...prev,
                                              image_url: "",
                                            }));
                                          }}
                                          style={{
                                            position: "absolute",
                                            top: "-10px",
                                            right: "50%",
                                            transform: "translateX(100px)",
                                            background: "#d7458f",
                                            border: "none",
                                            color: "white",
                                            borderRadius: "50%",
                                            width: "24px",
                                            height: "24px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                          }}
                                        >
                                          ×
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        <FontAwesomeIcon
                                          icon={faCloudUpload}
                                          style={{
                                            fontSize: "2.5rem",
                                            color: "#6455ED",
                                            marginBottom: "15px",
                                          }}
                                        />
                                        <div style={{ marginBottom: "10px" }}>
                                          <span style={{ color: "#666" }}>
                                            Drop an Image or{" "}
                                            <span
                                              style={{
                                                color: "#6455ED",
                                                textDecoration: "underline",
                                              }}
                                            >
                                              Browse
                                            </span>
                                          </span>
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "0.8rem",
                                            color: "#999",
                                          }}
                                        >
                                          *Max file size 2 MB
                                        </div>
                                      </>
                                    )}
                                    <input
                                      ref={fileInputRef}
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) =>
                                        handleFileSelected(e.target.files[0])
                                      }
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {errors.image_url && (
                                    <div
                                      className="error-message"
                                      style={{
                                        color: "red",
                                        fontSize: "0.875rem",
                                        marginTop: "0.5rem",
                                      }}
                                    >
                                      {errors.image_url}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="row mt-4 justify-content-center">
                            <div className="col-12 col-md-3">
                              <button
                                type="submit"
                                style={{
                                  backgroundColor: "#6455ED",
                                  color: "#fff",
                                  borderRadius: "25px",
                                  border: "none",
                                }}
                                className="btn mt-2 mb-2 w-100"
                              >
                                Submit Details
                              </button>
                            </div>
                            <div className="col-12 col-md-3">
                              <button
                                style={{
                                  backgroundColor: "#fff",
                                  border: "1px solid #D8DEE4",
                                  color: "#161619",
                                  borderRadius: "25px",
                                }}
                                className="btn mt-2 mb-2 w-100"
                                onClick={handleClearAll}
                              >
                                Clear all
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                </>
              ) : (
                ""
              )}
              <Modal shown={modalShown} close={handleModalClose}>
                <div className="text-center mb-2">
                  <img
                    src={
                      modalType === "success"
                        ? successDialogSvg
                        : requestFailedSvg
                    }
                    alt={modalType === "success" ? "Success" : "Failed"}
                    style={{
                      width: "80px",
                      height: "60px",
                      marginBottom: "15px",
                      objectFit: "contain",
                    }}
                  />
                  <h5 className="pt-3">
                    {modalType === "success"
                      ? "Your form has been submitted successfully!"
                      : "Form submission failed. Please try again."}
                  </h5>
                </div>
              </Modal>
              {showPopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                    padding: "15px",
                  }}
                  onClick={closePopup}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      backgroundColor: "#fff",
                      padding: "35px",
                      borderRadius: "8px",
                      width: "90%",
                      maxWidth: "600px",
                      maxHeight: "90vh",
                      position: "relative",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <button
                      onClick={closePopup}
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "12px",
                        background: "none",
                        border: "none",
                        fontSize: "20px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "#666",
                        padding: "4px",
                        lineHeight: "1",
                        zIndex: 1,
                      }}
                    >
                      ✖
                    </button>
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        paddingTop: "100%",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={popupImageUrl}
                        alt="Reference Photo"
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {showImageUpload && (
                <>
                  {showUploadPopup && (
                    <div
                      className="modal-backdrop"
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          padding: "30px",
                          borderRadius: "12px",
                          maxWidth: "737px",
                          maxHeight: "438px",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                        }}
                      >
                        <button
                          onClick={() => setShowUploadPopup(false)}
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "5px",
                            background: "none",
                            border: "none",
                            fontSize: "30px",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button>

                        <h4
                          style={{
                            marginBottom: "20px",
                            marginTop: "-10px",
                            fontSize: "18px",
                          }}
                        >
                          Upload Image
                        </h4>

                        <div
                          onDragEnter={handleDragEnter}
                          onDragOver={(e) => e.preventDefault()}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                          style={{
                            border: `4px dashed ${
                              isDraggingFile ? "#888888" : "#ddd"
                            }`,
                            borderRadius: "8px",
                            padding: "40px 20px",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          <FontAwesomeIcon
                            icon={faCloudUpload}
                            style={{
                              fontSize: "3rem",
                              color: "#6455ED",
                              marginBottom: "15px",
                            }}
                          />
                          <p style={{ margin: "0", color: "#666" }}>
                            Drag and drop your image here or
                            <span
                              style={{
                                color: "#6455ED",
                                textDecoration: "underline",
                                marginLeft: "5px",
                              }}
                            >
                              browse
                            </span>
                          </p>
                          <p
                            style={{
                              fontSize: "0.8rem",
                              color: "#999",
                              marginTop: "10px",
                            }}
                          >
                            Image will be cropped to 600 × 600 pixels • Max file
                            size: 2MB
                          </p>
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleFileSelected(e.target.files[0])
                            }
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {showCropPopup && (
                    <div
                      className="modal-backdrop"
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          padding: "30px",
                          borderRadius: "12px",
                          width: "737px",
                          height: "438px",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                        }}
                      >
                        <button
                          onClick={() => {
                            setShowCropPopup(false);
                            setImageSrc(null);
                          }}
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "5px",
                            background: "none",
                            border: "none",
                            fontSize: "30px",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button>

                        <h4 style={{ marginBottom: "15px", fontSize: "18px" }}>
                          {/* Crop Image */}
                        </h4>

                        <div
                          style={{
                            flex: "1",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "15px",
                            minHeight: "320px",
                            overflow: "hidden",
                          }}
                        >
                          <canvas
                            ref={canvasRef}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              cursor: isDragging ? "grabbing" : "default",
                            }}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            onMouseLeave={handleMouseUp}
                          />
                        </div>

                        <div
                          style={{
                            marginTop: "15px",
                            display: "flex",
                            gap: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <button
                            className="btn btn-secondary"
                            style={{
                              backgroundColor: "white",
                              color: "black",
                            }}
                            onClick={() => {
                              setShowCropPopup(false);
                              setImageSrc(null);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "#6455ED",
                              color: "#fff",
                            }}
                            onClick={handleUploadComplete}
                          >
                            Upload Image
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="redemption-form-footer">
            <Footer
              footerText={redemptionData.footerText}
              footerColor={redemptionData.footerColor}
              customerId={redemptionData.customerId}
            />
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};
